import { createBrowserHistory } from 'history';
import qhistory from 'qhistory';
import { stringify, parse } from 'qs';

export default qhistory(
  createBrowserHistory({ /* history configuration options */ }),
  stringify,
  parse,
);
